(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-main-product';

  function initSection(section) {
    if (!section || section.dataset.odditInit === 'true') return;
    section.dataset.odditInit = 'true';

    // Gallery: thumbnails drive the main image
    var thumbnails = section.querySelectorAll('.oddit-section-main-product__thumbnail');
    var slides = section.querySelectorAll('.oddit-section-main-product__slide');

    function setActiveMedia(index) {
      if (index < 0 || index >= thumbnails.length) return;

      thumbnails.forEach(function (t, i) {
        t.classList.toggle('oddit-section-main-product__thumbnail--active', i === index);
      });

      slides.forEach(function (slide) {
        var slideIndex = Number(slide.getAttribute('data-media-index'));
        var isActive = slideIndex === index;
        slide.classList.toggle('oddit-section-main-product__slide--active', isActive);
        if (isActive) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      scrollThumbnailIntoView(thumbnails[index]);
      scrollMainSlideIntoView(index);
    }

    // Bring the active thumbnail into view when it's clipped by the strip's overflow
    function scrollThumbnailIntoView(thumb) {
      var strip = section.querySelector('.oddit-section-main-product__thumbnails');
      if (!thumb || !strip) return;
      if (strip.scrollWidth <= strip.clientWidth + 1) return;

      var stripRect = strip.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var offset =
        thumbRect.left + thumbRect.width / 2 - (stripRect.left + stripRect.width / 2);
      strip.scrollBy({ left: offset, behavior: 'smooth' });
    }

    // On mobile the main image is a horizontal scroll-snap carousel — scroll the
    // chosen slide into view. On desktop (slides stacked, not scrollable) this
    // is a no-op.
    var mainImageEl = section.querySelector('.oddit-section-main-product__main-image');

    function getSlideByIndex(index) {
      for (var i = 0; i < slides.length; i++) {
        if (Number(slides[i].getAttribute('data-media-index')) === index) return slides[i];
      }
      return null;
    }

    function scrollMainSlideIntoView(index) {
      if (!mainImageEl) return;
      if (mainImageEl.scrollWidth <= mainImageEl.clientWidth + 1) return;
      var slide = getSlideByIndex(index);
      if (!slide) return;
      // Align the slide's start to the 16px gutter (matches scroll-snap-align:
      // start + scroll-padding-inline: 16px on mobile).
      var left = slide.offsetLeft - 16;
      mainImageEl.scrollTo({ left: left, behavior: 'smooth' });
    }

    // While the user swipes the mobile carousel, keep the active thumbnail in
    // sync with whichever slide is centered (without re-scrolling the carousel).
    if (mainImageEl) {
      var galleryRaf = null;
      mainImageEl.addEventListener(
        'scroll',
        function () {
          if (mainImageEl.scrollWidth <= mainImageEl.clientWidth + 1) return;
          if (galleryRaf) cancelAnimationFrame(galleryRaf);
          galleryRaf = requestAnimationFrame(function () {
            var pos = mainImageEl.scrollLeft + 16;
            var best = 0;
            var bestDist = Infinity;
            slides.forEach(function (s) {
              // Nearest slide by start (matches scroll-snap-align: start, with the
              // 16px scroll-padding gutter).
              var d = Math.abs(s.offsetLeft - pos);
              if (d < bestDist) {
                bestDist = d;
                best = Number(s.getAttribute('data-media-index'));
              }
            });
            thumbnails.forEach(function (t) {
              t.classList.toggle(
                'oddit-section-main-product__thumbnail--active',
                Number(t.getAttribute('data-media-index')) === best
              );
            });
            scrollThumbnailIntoView(thumbnails[best]);
          });
        },
        { passive: true }
      );
    }

    function getActiveIndex() {
      var active = section.querySelector('.oddit-section-main-product__thumbnail--active');
      return active ? Array.prototype.indexOf.call(thumbnails, active) : 0;
    }

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveMedia(Number(thumb.getAttribute('data-media-index')));
      });
    });

    // Drag-to-scroll for the thumbnail row (mouse only; touch keeps native scroll)
    var thumbStrip = section.querySelector('.oddit-section-main-product__thumbnails');
    if (thumbStrip) {
      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var dragged = false;

      var updateDraggable = function () {
        var scrollable = thumbStrip.scrollWidth > thumbStrip.clientWidth + 1;
        thumbStrip.classList.toggle('oddit-section-main-product__thumbnails--draggable', scrollable);
      };
      updateDraggable();
      window.addEventListener('resize', updateDraggable);

      thumbStrip.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        dragged = false;
        startX = e.clientX;
        startScroll = thumbStrip.scrollLeft;
        // Do NOT capture the pointer yet — capturing on a plain click makes the
        // browser dispatch the click to the strip instead of the thumbnail,
        // which would break thumbnail navigation. Capture only once a drag starts.
      });

      thumbStrip.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (!dragged && Math.abs(dx) > 3) {
          dragged = true;
          thumbStrip.setPointerCapture(e.pointerId);
          thumbStrip.classList.add('is-dragging');
        }
        if (!dragged) return;
        thumbStrip.scrollLeft = startScroll - dx;
        e.preventDefault();
      });

      var endDrag = function (e) {
        if (!isDown) return;
        isDown = false;
        thumbStrip.classList.remove('is-dragging');
        if (e && e.pointerId != null && thumbStrip.hasPointerCapture(e.pointerId)) {
          thumbStrip.releasePointerCapture(e.pointerId);
        }
      };
      thumbStrip.addEventListener('pointerup', endDrag);
      thumbStrip.addEventListener('pointercancel', endDrag);

      // Swallow the click that ends a drag so it doesn't reselect a thumbnail
      thumbStrip.addEventListener(
        'click',
        function (e) {
          if (dragged) {
            e.stopPropagation();
            e.preventDefault();
            dragged = false;
          }
        },
        true
      );
    }

    // ---- Variant switching: keep price, size suffix, buy button & plan prices in sync ----
    var variants = [];
    var variantScript = section.querySelector('[data-oddit-mp-variants]');
    if (variantScript) {
      try {
        variants = JSON.parse(variantScript.textContent) || [];
      } catch (e) {
        variants = [];
      }
    }

    function getSelectedOptions() {
      var groups = section.querySelectorAll('.oddit-section-main-product__option-group');
      var selected = [];
      groups.forEach(function (group) {
        var pos = Number(group.getAttribute('data-option-position'));
        var active = group.querySelector(
          '.oddit-section-main-product__option--active, .oddit-section-main-product__flavor--active'
        );
        if (active && pos) selected[pos - 1] = active.getAttribute('data-option-value');
      });
      return selected;
    }

    function findVariant(selected) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.options || v.options.length !== selected.length) continue;
        var match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== selected[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updateVariant() {
      if (!variants.length) return;
      var selected = getSelectedOptions();
      var variant = findVariant(selected);
      if (!variant) return;

      // Buy button: variant id, availability, label shell (price filled by updateMainPrice)
      var atc = section.querySelector('[data-add-to-cart]');
      if (atc) {
        atc.setAttribute('data-variant-id', variant.id);
        atc.disabled = !variant.available;
        var labelEl = atc.querySelector('[data-button-label]');
        if (labelEl) {
          if (variant.available) {
            var atcLabel = atc.getAttribute('data-atc-label') || 'Add to cart';
            labelEl.innerHTML =
              atcLabel + ' &nbsp;&bull;&nbsp; <span data-price-label></span>';
          } else {
            labelEl.textContent = 'Sold out';
          }
        }
      }

      // Selling-plan card prices, compare-at & save badge
      refreshSellingPlans(variant);
      // Headline price + compare-at + buy-button price
      updateMainPrice();
    }

    // Update the main price (with strike-through compare-at when a discounted
    // plan is active) and the buy-button price, for the current variant & plan.
    function updateMainPrice() {
      var variant = findVariant(getSelectedOptions());
      if (!variant) return;

      var planId = getActiveSellingPlanId();
      var allocation = planId && variant.sellingPlans ? variant.sellingPlans[planId] : null;
      var hasDiscount = allocation && allocation.savings > 0;
      var price = allocation ? allocation.price : variant.price;

      var priceEl = section.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = price;

      var compareEl = section.querySelector('[data-price-compare]');
      if (compareEl) {
        if (hasDiscount) {
          compareEl.textContent = allocation.compareAt;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      var priceLabel = section.querySelector('[data-price-label]');
      if (priceLabel) priceLabel.textContent = price;
    }

    // Update each selling-plan card (price, strike-through compare, save badge)
    // for the given (or current) variant, using that card's selected plan id.
    function refreshSellingPlans(variant) {
      variant = variant || findVariant(getSelectedOptions());
      if (!variant) return;

      var planEls = section.querySelectorAll('.oddit-section-main-product__selling-plan');
      planEls.forEach(function (planEl) {
        var planId = planEl.getAttribute('data-selling-plan-id');
        var priceStrong = planEl.querySelector('.oddit-section-main-product__selling-plan-price');
        var compareEl = planEl.querySelector('.oddit-section-main-product__selling-plan-compare');
        var savingsEl = planEl.querySelector('[data-selling-plan-savings]');
        var tagEl = planEl.querySelector('[data-selling-plan-tag]');
        var allocation = planId && variant.sellingPlans ? variant.sellingPlans[planId] : null;

        if (allocation) {
          if (priceStrong) priceStrong.textContent = allocation.price;
          if (compareEl) compareEl.textContent = allocation.compareAt;
          if (savingsEl) savingsEl.textContent = 'Save ' + allocation.savings + '%';
          if (tagEl) tagEl.hidden = !(allocation.savings > 0);
        } else {
          // One-time purchase / no allocation: show the regular variant price, no strike-through.
          if (priceStrong) priceStrong.textContent = variant.price;
          if (compareEl) compareEl.textContent = '';
        }
      });
    }

    function selectOption(btn, siblings, activeClass) {
      siblings.forEach(function (el) {
        el.classList.remove(activeClass);
        el.setAttribute('aria-checked', 'false');
      });
      btn.classList.add(activeClass);
      btn.setAttribute('aria-checked', 'true');

      var group = btn.closest('.oddit-section-main-product__option-group');
      if (group) {
        var labelEl = group.querySelector('[data-selected-option-value]');
        if (labelEl) labelEl.textContent = btn.getAttribute('data-option-value');
      }
      updateVariant();
    }

    // Variant option pill selection (Bag Size, etc.). Scoped to the variant
    // picker so the collection-tabber's pills/cards (which reuse these classes)
    // are not bound to variant-selection logic.
    var variantPicker = section.querySelector('.oddit-section-main-product__variant-picker');
    var optionLists = variantPicker
      ? variantPicker.querySelectorAll('.oddit-section-main-product__option-list--pill')
      : [];
    optionLists.forEach(function (list) {
      var options = list.querySelectorAll('.oddit-section-main-product__option--pill');
      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          selectOption(opt, options, 'oddit-section-main-product__option--active');
        });
      });
    });

    // Variant flavor card selection (swatch options). Also scoped to the variant picker.
    var flavorList = variantPicker
      ? variantPicker.querySelector('.oddit-section-main-product__option-list--card')
      : null;
    if (flavorList) {
      var flavors = flavorList.querySelectorAll('.oddit-section-main-product__flavor');
      flavors.forEach(function (flavor) {
        flavor.addEventListener('click', function () {
          selectOption(flavor, flavors, 'oddit-section-main-product__flavor--active');
        });
      });
    }

    // Collection tabber: product-type tabs switch which collection's flavor
    // cards are shown (cards are links that navigate). Mirrors the legacy
    // openCollection() show/hide; the active tab is pre-selected server-side.
    var tabber = section.querySelector('[data-oddit-tabber]');
    if (tabber) {
      var tabberTabs = tabber.querySelectorAll('[data-tabber-tab]');
      var tabberPanels = tabber.querySelectorAll('[data-tabber-panel]');
      var tabberSelectedType = tabber.querySelector('[data-tabber-selected-type]');
      tabberTabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = tab.getAttribute('data-tabber-tab');
          tabberTabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('oddit-section-main-product__option--active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          tabberPanels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-tabber-panel') !== index;
          });
          if (tabberSelectedType) {
            tabberSelectedType.textContent = tab.getAttribute('data-tabber-type') || '';
          }
        });
      });
    }

    // Selling plan selection (Subscribe vs One-Time)
    var sellingPlans = section.querySelectorAll('.oddit-section-main-product__selling-plan');

    function activatePlanCard(card) {
      sellingPlans.forEach(function (p) {
        p.classList.remove('oddit-section-main-product__selling-plan--active');
        p.setAttribute('aria-checked', 'false');
      });
      card.classList.add('oddit-section-main-product__selling-plan--active');
      card.setAttribute('aria-checked', 'true');
      // Switching purchase option changes the headline price
      updateMainPrice();
    }

    sellingPlans.forEach(function (plan) {
      plan.addEventListener('click', function () {
        activatePlanCard(plan);
      });
    });

    function getActiveSellingPlanId() {
      var activeCard = section.querySelector('.oddit-section-main-product__selling-plan--active');
      return activeCard ? activeCard.getAttribute('data-selling-plan-id') || '' : '';
    }

    // Delivery dropdown drives which subscription selling plan is selected
    var planSelect = section.querySelector('[data-selling-plan-select]');
    var subscriptionCard = section.querySelector('[data-subscription-card]');
    if (planSelect && subscriptionCard) {
      // Keep the dropdown in sync with the card's initial plan
      var initialPlanId = subscriptionCard.getAttribute('data-selling-plan-id');
      if (initialPlanId) planSelect.value = initialPlanId;

      // Focusing/opening the dropdown means the shopper wants the subscription option
      planSelect.addEventListener('focus', function () {
        activatePlanCard(subscriptionCard);
      });
      // Don't let the click bubble to the card handler (it would re-run unnecessarily)
      planSelect.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      planSelect.addEventListener('change', function () {
        subscriptionCard.setAttribute('data-selling-plan-id', planSelect.value);
        activatePlanCard(subscriptionCard);
        refreshSellingPlans();
      });
    }

    // Gallery prev/next cycle through the media
    var prevBtn = section.querySelector('.oddit-section-main-product__gallery-prev');
    var nextBtn = section.querySelector('.oddit-section-main-product__gallery-next');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (thumbnails.length === 0) return;
        var idx = getActiveIndex();
        setActiveMedia((idx - 1 + thumbnails.length) % thumbnails.length);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (thumbnails.length === 0) return;
        var idx = getActiveIndex();
        setActiveMedia((idx + 1) % thumbnails.length);
      });
    }

    // Keep accordions click-only. The theme's global custom-script.js force-opens
    // every <details> on hover (desktop); we manage the open state on click and
    // revert any hover-driven change (the observer fires before paint, no flicker).
    var accordionItems = section.querySelectorAll('.oddit-section-main-product__accordion');
    accordionItems.forEach(function (details) {
      var summary = details.querySelector('.oddit-section-main-product__accordion-header');
      if (!summary) return;
      var desiredOpen = details.hasAttribute('open');

      function syncOpen() {
        if (desiredOpen) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
        summary.setAttribute('aria-expanded', desiredOpen ? 'true' : 'false');
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        desiredOpen = !desiredOpen;
        syncOpen();
      });

      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(function () {
          if (details.hasAttribute('open') !== desiredOpen) syncOpen();
        }).observe(details, { attributes: true, attributeFilter: ['open'] });
      }

      syncOpen();
    });

    // Add-to-cart loading-state (static preview demo; production uses OdditCartDrawer)
    var atcButtons = section.querySelectorAll('[data-add-to-cart]');
    atcButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.OdditCartDrawer && typeof window.OdditCartDrawer.addToCart === 'function') {
          var variantId = Number(btn.getAttribute('data-variant-id'));
          if (!variantId) return;
          var restWidth = btn.getBoundingClientRect().width;
          btn.style.minWidth = restWidth + 'px';
          btn.disabled = true;
          btn.classList.add('is-loading');
          btn.setAttribute('aria-busy', 'true');

          // Include the selected subscription selling plan, if any (one-time = empty id).
          // Only the main buy button participates in the subscription picker — the
          // cross-sell card is always a plain one-time add, so it must NOT inherit
          // the main product's selling plan (that plan has no allocation on the
          // upsell variant and would make /cart/add.js reject the request).
          var isMainAtc = btn.classList.contains('oddit-section-main-product__add-to-cart');
          var sellingPlanId = isMainAtc ? getActiveSellingPlanId() : '';
          var addPromise;
          if (sellingPlanId && typeof window.OdditCartDrawer.addMultipleToCart === 'function') {
            addPromise = window.OdditCartDrawer.addMultipleToCart([
              { id: variantId, quantity: 1, selling_plan: Number(sellingPlanId) }
            ]);
          } else {
            addPromise = window.OdditCartDrawer.addToCart(variantId, 1);
          }

          addPromise
            .then(function () {
              window.OdditCartDrawer.open();
            })
            .finally(function () {
              btn.disabled = false;
              btn.classList.remove('is-loading');
              btn.removeAttribute('aria-busy');
              btn.style.minWidth = '';
            });
        }
      });
    });

    // Sync the headline price with the default-active purchase option on load
    updateMainPrice();
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are reloaded in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });
})();